// ============================================================================
// Notifications API helpers.
//
// Backend: notifications.Notification (see backend/notifications/views.py).
// The list endpoint auto-scopes to the caller. `?unread=1` filters to
// unread; `?kind=...` filters by event kind (e.g. `lab_result.ready`).
// ============================================================================

import { api } from './client.js'
import { endpoints } from './endpoints.js'
import { unwrapList } from '../utils/format.js'

export async function listNotifications({ unread, kind, page_size = 100 } = {}) {
  const params = { page_size }
  if (unread) params.unread = 1
  if (kind) params.kind = kind
  const { data } = await api.get(endpoints.notificationList, { params })
  return unwrapList(data)
}

export async function markNotificationRead(id) {
  const { data } = await api.post(endpoints.notificationMarkRead(id))
  return data
}

export async function markAllNotificationsRead() {
  const { data } = await api.post(endpoints.notificationMarkAllRead)
  return data // { updated: N }
}
